module.exports = __webpack_public_path__ + "static/media/dts.592aad03.png";